import { render, staticRenderFns } from "./attachFileCategoryTag.vue?vue&type=template&id=b8f36afa"
import script from "./attachFileCategoryTag.vue?vue&type=script&lang=js"
export * from "./attachFileCategoryTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports